import PropTypes from 'prop-types';

import EBPropTypes from 'js-utils/prop-types';

export const EVENTS_PROPTYPES = PropTypes.arrayOf(
    PropTypes.shape({
        id: PropTypes.string.isRequired,
    }),
);

export const SEE_MORE_PROPTYPE = PropTypes.shape({
    url: PropTypes.string,
});

export const ORGANIZER_ARTICLE_PROPTYPE = PropTypes.shape({
    profileUrl: PropTypes.string.isRequired,
    profileImage: PropTypes.string.isRequired,
    articleImage: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    summary: PropTypes.string,
    description: PropTypes.string,
    subDescription: PropTypes.string,
    upcoming: PropTypes.string,
});

export const BUCKETS_PROPTYPES = PropTypes.arrayOf(
    PropTypes.shape({
        key: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        name: EBPropTypes.translation,
        subtitle: EBPropTypes.translation,
        events: EVENTS_PROPTYPES,
        seeMore: SEE_MORE_PROPTYPE,
    }),
);

export const BUCKET_CONFIG_PROPTYPE = PropTypes.shape({
    featureFlagName: PropTypes.string,
    layout: PropTypes.shape({
        desktop: PropTypes.object,
    }),
});

export const ORGANIZER_ARTICLE_BUCKET_PROPTYPE = PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    organizerArticles: PropTypes.arrayOf(ORGANIZER_ARTICLE_PROPTYPE),
});

export const FLAT_BUCKET_PROPTYPE = PropTypes.shape({
    result: EVENTS_PROPTYPES,
});

export const FEED_CONFIG_PROPTYPES = PropTypes.objectOf(BUCKET_CONFIG_PROPTYPE);

export const FEATURE_FLAGS_PROPTYPES = PropTypes.objectOf(PropTypes.bool);

export const EVENT_SEARCH_PROPTYPES = PropTypes.shape({
    dates: PropTypes.arrayOf(PropTypes.string),
    price: PropTypes.string,
    tags: PropTypes.string,
});

export const FOLLOW_PROPTYPES = PropTypes.arrayOf(PropTypes.string);

const TOP_SUGGESTION = PropTypes.shape({
    slug: PropTypes.string,
    placeType: PropTypes.string,
    currentPlace: PropTypes.string,
    currentPlaceParent: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    value: PropTypes.string,
    content: PropTypes.string,
    secondaryContent: PropTypes.string,
});

export const LOCATION_PROP_TYPE = PropTypes.shape({
    suggestions: PropTypes.array,
    slug: PropTypes.string,
    placeId: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    bbox: PropTypes.object,
    currentPlace: PropTypes.string,
    currentPlaceParent: PropTypes.string,
    placeType: PropTypes.string,
    isWaitingForLocation: PropTypes.bool,
    isUsingCurrentLocation: PropTypes.bool,
    locationDenied: PropTypes.bool,
    isOnline: PropTypes.bool,
    topSuggestions: PropTypes.arrayOf(TOP_SUGGESTION),
});

export const EMPTY_STATES_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.shape({
        validation: PropTypes.shape({
            isAuthenticated: PropTypes.bool,
            useDefault: PropTypes.bool,
            shouldShowEmptyState: PropTypes.bool,
        }),
        config: PropTypes.shape({
            title: EBPropTypes.translation,
            iconType: PropTypes.object.isRequired,
            iconSize: PropTypes.string,
            description: EBPropTypes.translation,
            primaryLink: PropTypes.string,
            primaryText: EBPropTypes.translation,
        }),
    }),
);
